import { jwtDecode } from "jwt-decode";
import { useMemo } from "react";
import { signOutUser } from "../../behavior/api/auth";
import { clearTokenFromStorage } from "../../behavior/security/auth.service";
import useReadLocalStorage from "../../helpers/hooks/useReadLocalStorage";
import type { HubertUserJWTModel } from "../../types/authentication";

const getSessionToken = (rawToken: string | null) => {
    if (!rawToken || rawToken === "") return null;
    return {
        rawToken,
        user: rawToken ? jwtDecode<HubertUserJWTModel>(rawToken) : undefined,
    };
};

export const useMyHubertSession = () => {
    const rawToken = useReadLocalStorage<string>("candidate-hub-token", { parse: false });
    return useMemo(() => {
        let currentToken = getSessionToken(rawToken);
        let activeLogout: Promise<boolean> | null;
        return {
            get sessionToken() {
                return currentToken;
            },
            async logoutUser() {
                if (!activeLogout) {
                    activeLogout = (async () => {
                        if (!currentToken) return false;
                        currentToken = null;
                        try {
                            await signOutUser();
                        } catch {
                            // ignore sign out error
                        }
                        clearTokenFromStorage();
                        return true;
                    })();
                }

                try {
                    return await activeLogout;
                } finally {
                    activeLogout = null;
                }
            },
        };
    }, [rawToken]);
};
